/**
 * Shared utilities for portal product display (Story 7-3).
 */

export const AVAILABILITY_LABELS: Record<string, string> = {
  in_stock: "In Stock",
  low: "Limited Stock",
  out_of_stock: "Out of Stock",
};

export const AVAILABILITY_VARIANTS: Record<string, "success" | "warning" | "danger" | "neutral"> = {
  in_stock: "success",
  low: "warning",
  out_of_stock: "danger",
};

export function formatUnit(unit: string): string {
  const u = unit.toLowerCase();
  if (u === "pieces") return "per piece";
  if (u === "liters") return "per liter";
  if (u === "kg") return "per kg";
  if (u === "boxes") return "per box";
  if (u === "rolls") return "per roll";
  return `per ${unit}`;
}
